export const educationData = [
    {
        id: 1,
        institution: 'Scaler Academy, Banglore',
        course: 'Advanced Program in Artificial Intelligence and Machine Learning',
        startYear: 'Nov 2025',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'Sinhgad College of Engineering, Pune',
        course: 'Mechanical Engineering (BE)',
        startYear: 'May 2015',
        endYear: 'May 2019'
    },

]
